export const MIN_PASSWORD_LENGTH = 8;

export const LETTER_REGEX = /[a-zA-Z]/;

export const NUMBER_REGEX = /\d/;

export const VALID_USERNAME_REGEX = /^[a-zA-Z0-9_-]*$/i;

export const VALID_EMAIL_REGEX = '^(?:'
  + '(?:[-!#$%&\'*+/=?^_`{}|~0-9A-Z]+(?:\\.[-!#$%&\'*+/=?^_`{}|~0-9A-Z]+)*'
  + '|'
  + '"(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f!#-\\[\\]-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])*")'
  + ')@'
  + '(?:'
  + '(?:[A-Z0-9](?:[A-Z0-9-]{0,61}[A-Z0-9])?\\.)+(?:[A-Z0-9-]{2,63})'
  + '|'
  + '\\[(?:25[0-5]|2[0-4]\\d|[01]?\\d?\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|[01]?\\d?\\d)){3}\\]'
  + ')'
  + '$';

export const REGISTER_INITIAL_FORM_STATE = {
  email: '',
  username: '',
  password: '',
  confirm_password: '',
  honor_code: false,
};

export const REGISTER_INITIAL_CODE_STATE = {
  type: '',
  count: 0,
};

// Registration Error Codes
export const FORBIDDEN_REQUEST = 'forbidden-request';
export const FORM_SUBMISSION_ERROR = 'form-submission-error';
export const INTERNAL_SERVER_ERROR = 'internal-server-error';
export const DUPLICATE_EMAIL = 'duplicate-email';
export const DUPLICATE_EMAIL_USERNAME = 'duplicate-email-username';
